import React, { useState } from "react";
import ModalContainer from "../common/ModalContainer";
import PaymentMethodOdiopaySection from "../flight/PaymentMethodOdiopaySection";

function OdiopayPaymentModal({ open, setOpen, onPay, booking }) {
  const [data, setData] = useState({});
  return (
    <ModalContainer
      open={open}
      setOpen={setOpen}
      padding="px-4 py-6"
      title={"Price freeze with Odiopay"}
    >
      <div className="w-full flex flex-col">
        <div className="w-full">
          <div className="relative overflow-x-auto flex flex-col scroll-hide">
            <div className="flex flex-col p-4 w-full rounded-md">
              {open && (
                <PaymentMethodOdiopaySection
                  booking={booking}
                  setData={setData}
                />
              )}
              <button
                className="h-12 rounded-md w-full mt-4 bg-primary1 text-white flex items-center justify-center"
                onClick={() => {
                  setOpen(false);
                  onPay?.(data);
                }}
              >
                Pay installment using Intraverse Wallet
              </button>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
}

export default OdiopayPaymentModal;
